import { cn } from '@/utils/cn';

const Goal = ({ className, width = 14, height = 15 }: { className?: string; width?: number; height?: number }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('dark:text-white text-black', className)}
    >
      <g clipPath="url(#clip0_573_19836)">
        <path
          d="M13.3722 7.64071C13.3722 8.96185 12.9805 10.2533 12.2465 11.3518C11.5125 12.4503 10.4693 13.3064 9.24871 13.812C8.02814 14.3176 6.68506 14.4499 5.38931 14.1921C4.09356 13.9344 2.90334 13.2982 1.96916 12.364C1.03498 11.4298 0.398789 10.2396 0.141048 8.94387C-0.116692 7.64812 0.0155896 6.30504 0.521166 5.08447C1.02674 3.8639 1.88291 2.82067 2.98139 2.08668C4.07987 1.3527 5.37134 0.960938 6.69247 0.960938C8.46406 0.960938 10.1631 1.6647 11.4158 2.9174C12.6685 4.1701 13.3722 5.86912 13.3722 7.64071ZM12.0734 7.64071L11.372 8.25302L9.68353 6.67771L10.127 4.40473L11.0547 4.48823C10.3826 3.56085 9.43338 2.87084 8.34386 2.5177L8.71496 3.37864L6.69247 4.49751L4.6737 3.37308L5.04479 2.51213C3.95225 2.86429 3.00061 3.55592 2.32835 4.48637L3.2561 4.40288L3.69214 6.67585L2.00364 8.25117L1.31154 7.64071C1.30866 8.78353 1.67146 9.89731 2.34691 10.8192L2.55472 9.90627L4.83698 10.1939L5.81482 12.2906L5.02253 12.7693C6.11269 13.1237 7.2871 13.1237 8.37726 12.7693L7.56455 12.2906L8.54796 10.1939L10.8414 9.91369L11.0492 10.8266C11.7222 9.90132 12.0811 8.78482 12.0734 7.64071ZM5.39363 9.52218L4.59205 7.0618L6.69247 5.54029L8.79289 7.0618L7.99132 9.52218H5.39363Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_573_19836">
          <rect width="13.3595" height="13.3595" fill="currentColor" transform="translate(0.0126953 0.960938)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Goal;
